import React, { useState } from 'react';
import { Button, Card, Dropdown, Flex, Form, Space } from 'antd';
import ReactApexChart from 'react-apexcharts';
import { DownOutlined } from '@ant-design/icons';
import { ModuleTopHeading } from '../../PageComponents';

const ClientlistBarChart = () => {

  const [order, setOrder] = useState(4);
  const [form] = Form.useForm();
  const items = [
    { label: <a href="#">Today</a>, key: 0 },
    { label: <a href="#">Last Week</a>, key: 1 },
    { label: <a href="#">Last Month</a>, key: 2 },
    { label: <a href="#">Last Year</a>, key: 3 },
  ];

  const onClick = ({ key }) => {
    // key = parseInt(key) + 1;
    setOrder(key);
    // filter(key);
  };

  const chartData = {
    series: [
      {
        name: '11 April - 2024',
        data: [390, 365, 200, 260, 200, 290, 350, 170, 200, 370, 350,],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderRadiusApplication: 'end',
          columnWidth: '20%',
        }
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        categories: [
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
        ],
        labels: {
          style: {
            colors: '#000',
            fontSize: '10px',
            whiteSpace: 'pre-wrap',
          },
          rotate: 0,
          formatter: function (value) {
            // Split the label into multiple lines if it exceeds a certain length
            const maxCharsPerLine = 7;
            if (value.length > maxCharsPerLine) {
              return value.match(new RegExp(`.{1,${maxCharsPerLine}}`, 'g')); // Split into chunks
            }
            return value;
          },
        },
      },
      yaxis: {
        min: 0,
        max: 400,
        tickAmount: 5,
        labels: {
          style: {
            colors: '#000',
          },
        },
      },
      fill: {
        opacity: 1,
      },
      grid: {
        show: false,
      },
      colors: ['#0086FF', '#F56C89'],
      legend: {
        markers: {
          shape: "circle"
        }
      }
    },
  };


  return (
    <div>
      <Card className='shadow-d radius-12 card-cs'>
        <Flex justify='space-between' align='center' wrap gap={10}>
          <Flex vertical>
            <ModuleTopHeading level={5} name='Total Registered Clients' />
          </Flex>
          <Form form={form} layout="vertical">
            <Flex justify='end' gap={10}>
              <Dropdown
                  menu={{ items, onClick }}
                  trigger={['click']}
                  className='margin-top'
              >
                  <Button className=''>
                    <Space>
                      {
                        order == 0 ? 'Today' : 
                        order == 1 ? 'Last Week' :
                        order == 2 ? 'Last Month' :
                        order == 3 ? 'Last Year' : 'Filter'
                      }  
                      <DownOutlined />
                    </Space>
                  </Button>
              </Dropdown>
            </Flex>
          </Form>
        </Flex>
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={300}
          className='bar-width'
        />
      </Card>
    </div>
  );
};

export { ClientlistBarChart };
